<template>
  <div class="order-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">租房系统</el-breadcrumb-item>
      <el-breadcrumb-item>订单</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <div class="filter-container">
        <el-form :inline="true" :model="filterForm" class="demo-form-inline">
          <el-form-item label="用户名称">
            <el-input v-model="filterForm.userName" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="订单编号">
            <el-input v-model="filterForm.orderNumber" placeholder="请输入订单编号"></el-input>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="filterForm.status" placeholder="请选择状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="在租" value="在租"></el-option>
              <el-option label="已付定金" value="已付定金"></el-option>
              <el-option label="已到期" value="已到期"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="table-container">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="title" label="房源名称"></el-table-column>
          <el-table-column prop="userName" label="用户名称"></el-table-column>
          <el-table-column prop="orderNumber" label="订单编号"></el-table-column>
          <el-table-column prop="status" label="订单状态"></el-table-column>
          <el-table-column prop="type" label="类型"></el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
          <el-table-column prop="startTime" label="入住时间"></el-table-column>
          <el-table-column prop="endTime" label="到期时间"></el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getReq, postRed } from '@/api/axiosFun'

export default {
  name: 'RentalOrders',
  data() {
    return {
      filterForm: {
        userName: '',
        orderNumber: '',
        status: ''
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      // 获取token
      const token = localStorage.getItem('token') || '';

      // 构建请求参数
      const params = {
        page: this.pageSize, // 页码
        limit: this.currentPage,  // 每页条数
        orderNumber: this.filterForm.orderNumber || '',
        status: this.filterForm.status || '',
        userName: this.filterForm.userName || '',
        token: token
      };

      // 使用通用请求方法获取订单数据
      getReq('get', '/rentHouse/selectAllHouseOrder', params)
        .then(response => {
          if (response.status === 200) {
            const responseData = response.data || {};

            // 处理返回数据
            this.tableData = (responseData.list || []).map(item => {
              return {
                id: item.id,
                title: item.rentHouse && item.rentHouse.title || '',
                type: item.rentHouse && item.rentHouse.type || '',
                price: item.amount ? `${item.amount}/月` : '',
                status: this.getStatusText(item.status),
                startTime: item.startTime ? this.formatDate(item.startTime) : '',
                endTime: item.endTime ? this.formatDate(item.endTime) : '',
                userName: item.userName || '',
                orderNumber: item.orderNumber || ''
              };
            });
            this.total = responseData.totalRow || 0;
          } else {
            this.$message.error((response.data && response.data.message) || '获取订单列表失败');
            this.tableData = [];
            this.total = 0;
          }
        }).catch(error => {
          console.error('获取订单列表错误:', error);
          this.$message.error('获取订单列表失败，请重试');
          this.tableData = [];
          this.total = 0;
        });
    },
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '';
      try {
        const date = new Date(timestamp);
        // 保持年月日格式，但确保能正确处理带时分秒的输入
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      } catch (e) {
        console.error('日期格式化错误:', e);
        return timestamp;
      }
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        '0': '已付定金',
        '1': '在租',
        'expired': '已到期',
        '已支付': '已支付',
        '在租': '在租',
        '已退租': '已退租',
        '已逾期': '已逾期',
        '在租': '在租',
        '已付定金': '已付定金',
        '已到期': '已到期'
      };
      return statusMap[status] || '未知状态';
    },
    handleSearch() {
      this.currentPage = 1
      this.getList()
    },
    resetForm() {
      this.filterForm = {
        userName: '',
        orderNumber: '',
        status: ''
      }
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>

<style scoped>
.order-container {
  padding: 20px;
}
.filter-container {
  margin-bottom: 20px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/rentalSystem/orders.vue